import React from "react";
import "./Strategies.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCompassDrafting,
  faBullseye,
  faRocket,
  faChartPie,
  faSliders,
  faShieldHalved,
  faWandMagicSparkles,
  faRobot,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";

const strategies = [
  {
    icon: faCompassDrafting,
    title: "Growth Blueprint",
    description:
      "We build a clear plan: goals, funnel stages, KPIs, and the exact priorities for the next 30–60 days.",
    tag: "Plan",
    size: "lg",
    bullets: ["Goals + KPIs", "Funnel map", "Milestone roadmap"],
  },
  {
    icon: faBullseye,
    title: "Offers that Convert",
    description:
      "We sharpen your positioning and offer so visitors understand your value in seconds — and take action.",
    tag: "Offer",
    size: "lg",
    bullets: ["Messaging angles", "Value props", "Trust proof"],
  },
  {
    icon: faRocket,
    title: "Sprint Execution",
    description:
      "Weekly sprints to ship pages, creatives, tracking, and campaigns — fast, clean, and focused.",
    tag: "Speed",
  },
  {
    icon: faChartPie,
    title: "Channel Mix",
    description:
      "We choose where to play (SEO, Meta, Google, LinkedIn) based on demand and realistic budgets.",
    tag: "Growth",
  },
  {
    icon: faSliders,
    title: "Conversion System",
    description:
      "We improve headlines, CTAs, forms, speed, and trust so you get more leads without more spend.",
    tag: "CRO",
  },
  {
    icon: faWandMagicSparkles,
    title: "Creative Engine",
    description:
      "We test hooks + angles continuously. Winners scale, losers get replaced quickly.",
    tag: "Creatives",
  },
  {
    icon: faShieldHalved,
    title: "Tracking & Privacy",
    description:
      "Reliable tracking setup with privacy-safe configurations so your data is clean and decisions are confident.",
    tag: "Trust",
  },
  {
    icon: faRobot,
    title: "Automation Layer",
    description:
      "Lead capture → follow-up → CRM updates → reminders. Less leakage, faster closures.",
    tag: "Systems",
  },
];

const Strategies = () => {
  return (
    <section className="strX">
      <div className="strX__wrap">
        {/* Header */}
        <div className="strX__head">
          <span className="strX__badge">Strategy & Execution</span>
          <h2 className="strX__title">
            Built to <span>launch</span>, built to <span>scale</span>
          </h2>
          <p className="strX__sub">
            We combine clarity, conversion, and performance execution to create a
            growth system — not random marketing work.
          </p>
        </div>

        {/* Grid */}
        <div className="strX__grid">
          {strategies.map((s, i) => (
            <article
              className={`strX__card ${s.size === "lg" ? "is-lg" : ""}`}
              key={i}
            >
              <div className="strX__top">
                <div className="strX__ico">
                  <FontAwesomeIcon icon={s.icon} />
                </div>
                <span className="strX__tag">{s.tag}</span>
              </div>

              <h3 className="strX__h3">{s.title}</h3>
              <p className="strX__p">{s.description}</p>

              {s.bullets?.length ? (
                <div className="strX__bullets">
                  {s.bullets.map((b) => (
                    <span className="strX__bullet" key={b}>
                      {b}
                    </span>
                  ))}
                </div>
              ) : null}

              <div className="strX__more" aria-hidden="true">
                <span>Learn more</span>
                <FontAwesomeIcon icon={faArrowRight} />
              </div>
            </article>
          ))}
        </div>

        {/* Bottom strip */}
        <div className="strX__strip">
          <div className="strX__stripLeft">
            <h4>What this gives you</h4>
            <p>Clear roadmap • faster shipping • higher conversions • cleaner reporting</p>
          </div>
          <div className="strX__stripRight">
            <span className="chip">Weekly sprints</span>
            <span className="chip">Tracking setup</span>
            <span className="chip">Optimization cycles</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Strategies;